export const BUTTON_TEXT = {
  ERROR: "Error",
  ACTIVATE: "Activate",
  ACTIVATING: "Activating",
  ACTIVATED: "Activated",
  SUCCESS: "Success",
  TRY_AGAIN: "Try Again",
  DEACTIVATE:"Deactivate",
  DEACTIVATED:"Deactivated",
  SAVE: "Save"
}

export const DEFAULT_FORM_SETTINGS = {
  authKey: "",
  domainKey: "",
  secretKey: ""
}

const contactSupport =  <a href='https://www.clickcease.com/contact-us.html' target='_blank' rel="noreferrer">contact support</a>

export const ERROR = {
  BOTZAPPING_ACTIVATION: <>There was an error installing the tracking code, please try again or {contactSupport} for help</>,
  TRACKING_CODE_ACTIVATION: <>Failed activating tracking code. {contactSupport}</>,
  WHITELIST_UPDATE: <>Error updating whitelist, please try again or {contactSupport} for help</>,
  INVALID_IP: "Please enter a valid ip address",
  DUPLICATE_IP: "Please enter a new ip address"
}

export const HTTP_RESPONSE = {
  OK: 200,
  BAD_REQUEST: 400
}